import { render, staticRenderFns } from "./CustomerAccountView.vue?vue&type=template&id=25230fe0"
import script from "./CustomerAccountView.vue?vue&type=script&lang=js"
export * from "./CustomerAccountView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports